var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-anchor",
    style: _vm.styles
  }, [_c('div', {
    staticClass: "tag-line",
    style: _vm.lineStyle
  }), _vm.tailPosition !== 'none' ? _c('div', {
    staticClass: "tag-dot",
    style: {
      backgroundColor: _vm.tailColourEffective
    }
  }) : _vm._e(), _c('div', {
    ref: "el",
    staticClass: "tag-basic",
    class: [{
      'tag-basic--box-shadow': _vm.boxShadow
    }, {
      'tag-basic--sold-out-label': _vm.showSoldLabel
    }, {
      'tag-basic--filtered': _vm.filtered
    }],
    style: _vm.labelStyle,
    attrs: {
      "dir": _vm.activeLanguage.dir
    },
    domProps: {
      "innerHTML": _vm._s(_vm.parsedLabel)
    },
    on: {
      "click": _vm.triggerAction
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }